import React from "react";
import Header from "../Common/Header/Header";
import Footer from "../Common/Footer";
import "./ContactUs.css";

const ContactUs = () => {
  return (
    <section>
      <Header />
      <div className="contact-container">
        <div className="border" />
        <h1>Contact Us</h1>
        <div className="contact-upper">
          <div>
            <h3>Our Address</h3>
            <strong>
              Room - 611, Lift 5, Anam Rangs Plaza, <br />
              Dhanmondi 6/A, Satmosjid Road, <br /> Dhaka - Bangladesh 1207
            </strong>
          </div>
          <div>
            <h3>Visiting Hours</h3>
            <strong>Always Open</strong>
          </div>

          <div>
            <h3>Contacts</h3>
            <strong>Email:</strong> ferozlaw@gmail.com
            <br />
            <strong>Phone:</strong> +8801799-457351
          </div>
        </div>
        <div className="map">
          <div className="border" />
          <h1>Our Google Location</h1>
          <iframe
            title="map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3652.1383153132906!2d90.37156541027602!3d23.742446588993882!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755bfd6e093e051%3A0x21094536646f2898!2sFeroz%20Law%20Academy!5e0!3m2!1sen!2sbd!4v1703393900771!5m2!1sen!2sbd"
            width="100%"
            height="480"
            style={{ border: "0px" }}
            loading="lazy"
          ></iframe>
        </div>
      </div>
      <Footer />
    </section>
  );
};

export default ContactUs;
